import { Typography, Box, Button } from '@mui/material';
import { CalificationI } from 'types';
import {
  CalificationWrapper,
  CalificationCard,
  ConfettiContainer,
  ConfettiPiece,
  RainDrop,
} from './Calification.styled';
import { colors } from 'Constants/Colors';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import useTranslation from 'Hooks/useTranslation';
interface Props {
  calification: CalificationI;
}

const Calification = ({ calification }: Props) => {
  const history = useHistory();
  const { t2 } = useTranslation('course_test');

  /**
   * Genera las confetis cuando el usuario aprobó el examen
   */
  const confettiPieces = useMemo(() => {
    if (!calification.isApproved) return [];

    return Array.from({ length: 50 }, (_, i) => ({
      id: i,
      delay: Math.random() * 2,
      left: Math.random() * 100,
    }));
  }, [calification.isApproved]);

  /**
   * Genera las gotas cuando el usuario no aprobó el examen
   */
  const rainDrops = useMemo(() => {
    if (calification.isApproved) return [];

    return Array.from({ length: 100 }, (_, i) => ({
      id: i,
      delay: Math.random() * 2,
      left: Math.random() * 100,
    }));
  }, [calification.isApproved]);

  return (
    <>
      {calification.isApproved ? (
        <ConfettiContainer>
          {confettiPieces.map(piece => (
            <ConfettiPiece key={piece.id} $delay={piece.delay} $left={piece.left} />
          ))}
        </ConfettiContainer>
      ) : (
        <ConfettiContainer>
          {rainDrops.map(drop => (
            <RainDrop key={drop.id} $delay={drop.delay} $left={drop.left} />
          ))}
        </ConfettiContainer>
      )}
      <CalificationWrapper>
        <CalificationCard $isApproved={calification.isApproved}>
          <Box
            sx={{
              textAlign: 'center',
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h1"
              sx={{ mb: 2 }}
              className={calification.isApproved ? 'celebration-emoji' : 'sad-emoji'}
            >
              {calification.isApproved ? '🎉' : '😔'}
            </Typography>

            <Typography
              variant="h4"
              sx={{
                color: calification.isApproved ? colors.GREEN : colors.RED,
                mb: 2,
                fontWeight: 'bold',
              }}
            >
              {calification.isApproved ? t2('congratulations') : t2('we_are_sorry')}
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mt: 3,
                color: 'text.secondary',
              }}
            >
              {calification.isApproved ? t2('got_passing_grade') : t2('your_grade_not_pass')}
            </Typography>

            <Typography
              variant="h2"
              sx={{
                color: calification.isApproved ? colors.GREEN : colors.RED,
                fontWeight: 'bold',
                mt: 2,
              }}
            >
              {calification.grade}
            </Typography>
          </Box>
          <Button
            variant="contained"
            fullWidth
            onClick={() => history.push('/')}
            sx={{ mt: 2, backgroundColor: colors.BLACK, color: colors.WHITE, fontWeight: 'bold' }}
          >
            {t2('go_to_dashboard')}
          </Button>
        </CalificationCard>
      </CalificationWrapper>
    </>
  );
};

export default Calification;
